export const query = [
  "--------",
  "Daily",
  "Energy",
  "Oil",
  "Power",
  "Nuclear",
  "Natural Gas",
  "LNG",
  "CO2",
  "Coal",
  "Forex",
  "Renewables",
  "Wind",
  "Solar",
  "PPA",
  "HydroPower",
  "Hydrogen",
  "Biomass",
  "Geothermal",
  "Electric Vehicles",
];
